export default __webpack_public_path__ + "static/media/Asset Banner 2@3x.1a54233c.png";